module.exports = __webpack_public_path__ + "static/media/map-new-side-bar-logo.cb7bdb6c.svg";